import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ClapService } from "../../../service/ClapService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";
import { ChequeCultureService } from "../../../service/ChequeCultureService";


import { useDispatch, useSelector } from "react-redux";
import {
  setFiche,
  setIban,
  setMaxVal,
  setOptJustificatif,
  setPac,
} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { AgentService } from "../../../service/AgentService";

export const ChangementRibNoticeInformation = ({ mode, hiddenNoticeButton, onConfirm }) => {

    const createMode = 'create';
    const editMode = 'edit';

  const errors = {
    dod: 1,
    statut: 2,
    qf: 2,
    iban: 3,
    pac: 4,
    exercice:5,
    droits:6,
    siDossierValide:7,
    demandeEnCours:8,
  };

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);
  const [currentActionSociale, setCurrentActionSociale] = useState({});
  const [baremes, setBaremes] = useState([]);
  const [valParticipation, setValParticipation] = useState(0);
  const [enfants, setEnfants] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [isJustificatifRequis, setIsJustificatifRequis] = useState();
  const [ibanMembre, setIbanMembre] = useState(null);
  const [enfantsAgeIntervalle, setEnfantsAgeIntervalle] = useState({});
  const [displayError, setDisplayError] = useState([]);

  const [hiddenButton, hideButton] = useState(hiddenNoticeButton);
  const dispatch = useDispatch();
  const history = useHistory();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();

  const linkService = new LinkProviderService();


  const nextStep = () => {
    actionSocialeService.persistState(actionSociale);
    onConfirm(false);
    hideButton(true);
  };

  return (
  
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card " style={{ display: !displayBasic ? "block" : "none" }}>

            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >

            <b>Mes références bancaires seront utilisées pour percevoir sur mon compte en banque </b>les prestations du C.G.O.S,
              <ul>
                  <li>
                  Un seul et unique compte en banque peut être associé à mon compte C.G.O.S. Ce compte en banque sera utilisé pour l’ensemble des prestations.
                  </li>
              </ul> 
            <br/>

            <b> La modification de mes références bancaires sera prise en compte dès que le C.G.O.S l’aura contrôlée et validée. </b>
            <br/>

            <br/>
              <b> Si le compte en banque est </b>
              <ul>
                <li>
                  <b>Un compte personnel</b>, il doit être à <b>mon nom et prénom.</b>
                </li>
                <li>
                  <b>Un compte joint,</b> le nom de mon conjoint ne suffit pas, <b>mon nom doit également apparaître.</b>
                </li>               
                <li>
                  <span><b>Un compte sur lequel mon nom n’est pas indiqué comme titulaire</b>, il est inutile de l’enregistrer car il ne pourra pas être validé par le C.G.O.S.</span>
                </li>               
                <li>
                  <span><b>Un compte livret</b>, il est inutile de l’enregistrer car il ne pourra pas être validé par le C.G.O.S.</span>
                </li>
              </ul>


            </span>
          
        
          <div className="tutorial">
            <img className="tutorial-image" src="/assets/icon_youtube.png" />{" "}
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
            >
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
                #TutorielCGOS - Comment scanner un document
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
